import { createSelector, Selector } from '@reduxjs/toolkit'
import { EntityType, FxRateDetail } from 'api'
import { GlobalState } from 'store'
import { createAllEntityUpdatesSelector } from './entitySelectors'

export const fxRateDetailsSelector: Selector<GlobalState, FxRateDetail[]> = createSelector(
  createAllEntityUpdatesSelector(EntityType.FX_RATE),
  fxRateUpdates =>
    fxRateUpdates.map(fxRateUpdate => ({
      fxRate: fxRateUpdate.entity,
      availableEvents: fxRateUpdate.availableEvents
    }))
)
